// init
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

const GLOBAL_NS = 'laMercedes';

let smootherInstance = null;

function setGlobalSmoother(smoother) {
    if (!window[GLOBAL_NS]) {
        window[GLOBAL_NS] = {};
    }

    window[GLOBAL_NS].smoother = smoother;
    // Compatibilidad con código existente.
    window.gsapSmoother = smoother;
}

export function getGlobalSmoother() {
    return (window[GLOBAL_NS] && window[GLOBAL_NS].smoother) || window.gsapSmoother || null;
}

function smoothScroll() {

    if (smootherInstance) {
        return;
    }

    const smoother = ScrollSmoother.create({
        wrapper: "#smooth-wrapper",
        content: "#smooth-content",
        effects: true,
        preventDefault: true,
        smooth: 1,
        normalizeScroll: false,
    });

    smootherInstance = smoother;

    console.log('[smoothScroll] ScrollSmoother initialized');

    // Exportar smoother para poder acceder desde otros módulos
    setGlobalSmoother(smoother);

    // Exponer para debug puntual en consola
    window.smoother = smootherInstance;

    // Anchors: interceptar clicks en enlaces internos con # y usar scrollTo de smoother
    document.addEventListener('click', (e) => {
        const anchor = e.target.closest('a[href^="#"]');
        if (!anchor) return;

        const hash = anchor.getAttribute('href');
        if (hash === '#') return;

        const target = document.querySelector(hash);
        if (!target) return;

        e.preventDefault();
        smoother.scrollTo(target, true, 'top top');
    });

}

export default smoothScroll;